import { connect } from 'react-redux'
import PostPhotographicComponent from '../components/PostPhotographicComponent.jsx';
import {
	forwardToExpandMenuMax,
	forwardToUploadPostPhoto,
	forwardToMarkPostQueue,
	forwardToMarkPostPop,
	forwardToFindPostPhotos,
	cleanAuditingAlert,
	forwardChangeIsLoadingPage2
} from '../actions';

const mapStateToProps = (state) => ({
	request: state.getIn(['maintenanceAuditingReducer', 'request']),
	response: state.getIn(['maintenanceAuditingReducer', 'response']),
	options: state.getIn(['maintenanceAuditingReducer', 'options']),
	alert: state.getIn(['maintenanceAuditingReducer', 'alert']),

	isLoadingPage: state.getIn(['maintenanceAuditingReducer', 'isLoadingPage']),

	menu: state.getIn(['menuReducer', 'menu']),
})

const mapDispatchToProps = (dispatch) => ({

	expandContent: () => {
		dispatch(forwardToExpandMenuMax());
	},
	uploadPhoto: (dataUri, card, type, operator) => {
		dispatch(forwardToUploadPostPhoto(dataUri, card, type, "POST", operator));
	},
	queue: () => {
		dispatch(forwardToMarkPostQueue());
	},
	findPhotos: (card, type) => {
		dispatch(forwardToFindPostPhotos(card, type, "POST"));
	},
	pop: (dataUri) => {
		dispatch(forwardToMarkPostPop(dataUri));
	},
	cleanAlert: () => {
		dispatch(cleanAuditingAlert());
	},
	changeIsLoadingPage: (isLoading) => {
		dispatch(forwardChangeIsLoadingPage2(isLoading));
	}
})

const PostPhotographicContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(PostPhotographicComponent)

export default PostPhotographicContainer;


// WEBPACK FOOTER //
// ./src/containers/PostPhotographicContainer.jsx